import { Box, Typography } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import useStyles from "./style.js";
import { useMediaQuery } from "@material-ui/core";
const CirclesBanner = (props) => {
  const classes = useStyles();
  const mobile = useMediaQuery("(max-width:768px)");
  return (
    <Box
      component="div"
      className={!mobile ? classes.driver : classes.driverMob}
    >
      <Box component="div" className={classes.circleCont}>
        <Box component="div" className={classes.circleMob}>
          <AccessTimeIcon
            className={!mobile ? classes.icon : classes.iconMob}
          />
          <Typography
            className={!mobile ? classes.text : classes.textMob}
            p="true"
          >
            {props.circlesSettings.third}
          </Typography>
        </Box>
      </Box>

      <Box component="div" className={classes.circleCont}>
        <Box component="div" className={classes.circleMob}>
          <VerifiedUserIcon
            className={!mobile ? classes.icon : classes.iconMob}
          />
          <Typography
            className={!mobile ? classes.text : classes.textMob}
            p="true"
          >
            {props.circlesSettings.second}
          </Typography>
        </Box>
      </Box>

      <Box component="div" className={classes.circleCont}>
        <Box component="div" className={classes.circleMob}>
          <AttachMoneyIcon
            className={!mobile ? classes.icon : classes.iconMob}
          />
          <Typography
            className={!mobile ? classes.text : classes.textMob}
            p="true"
          >
            {props.circlesSettings.first}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CirclesBanner;
